import { gql } from '@apollo/client'

const FAQ_FIELDS = gql`
  fragment FAQFields on FaqType {
    id
    question
    answerAsHtml
    page
    order
    type
  }
`

export const FIND_ALL_FAQ = gql`
  ${FAQ_FIELDS}
  query FindAllFaq($query: FaqQueryInput!) {
    findAllFaq(query: $query) {
      items {
        ...FAQFields
      }
      count
    }
  }
`

export const BULK_CREATE_UPDATE_FAQ = gql`
  ${FAQ_FIELDS}
  mutation BulkCreateUpdateFaq($createFaqInput: [BulkCreateUpdateFaqInput!]!) {
    bulkCreateUpdateFaq(createFaqInput: $createFaqInput) {
      ...FAQFields
    }
  }
`

export const BULK_REMOVE_FAQ = gql`
  mutation BulkRemoveFaq($ids: [LinkFaqInput!]!) {
    bulkRemoveFaq(ids: $ids) {
      raw
      affected
    }
  }
`
